<script setup lang="ts">
import TemplateIcon from "@/components/UI/icons/TemplateIcon.vue";
import { useGetReportTemplate } from "@/stores/queries/report-templates.query";
import ReportState from "@/stores/report/ReportState";
import { computed } from "vue";

defineEmits<{
  (e: "click"): void;
  (e: "settings"): void;
}>();

const templateId = computed(() => ReportState.activeTemplateId);
const { data: reportTemplate } = useGetReportTemplate(templateId);
</script>

<template>
  <div class="btn-group-joined d-flex align-items-center">
    <button
      class="template-selector d-flex align-items-center gap-3 px-4 py-2 border-0"
      @click="$emit('click')"
    >
      <TemplateIcon :size="32" />
      <span class="template-name text-truncate">
        {{ reportTemplate?.name ?? $t("report:choose.template") }}
      </span>
      <el-icon size="18"><i class="bi-chevron-down"></i></el-icon>
    </button>

    <button
      v-if="templateId"
      class="settings-btn d-flex align-items-center justify-content-center border-0"
      @click="$emit('settings')"
      :title="$t('settings')"
    >
      <el-icon size="20"><i class="bi-gear"></i></el-icon>
    </button>
  </div>
</template>

<style lang="scss" scoped>
.btn-group-joined {
  border-radius: 8px;
  overflow: hidden;
}

.template-selector {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  cursor: pointer;
  max-width: 300px;
  height: 44px;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
}

.template-name {
  font-size: 15px;
  font-weight: 500;
  max-width: 200px;
}

.settings-btn {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  cursor: pointer;
  width: 44px;
  height: 44px;
  border-left: 1px solid rgba(255, 255, 255, 0.15) !important;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
}
</style>
